export default "__VITE_ASSET__BKCIdZYY__"